export default __webpack_public_path__ + "assets/sounds/81bfa3abc4eb47608cbd9981b52fc01b.mp3";